<template>
    <div class="px-3 pt-3" role="tabpanel">
        <form @keyup.enter="submit" class="form-horizontal auth-form my-4">
            <h5 class="text-danger text-center" v-if="errorMsg">{{ errorMsg }}</h5>
            <div class="form-group">
                <label for="email">Email</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm far fa-user"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.userData.email.$error }"
                            class="form-control"
                            id="email"
                            name="email"
                            placeholder="Entrez votre e-mail"
                            type="email"
                            v-model.trim="$v.userData.email.$model"
                    />
                    <div class="invalid-feedback" v-if="!$v.userData.email.required">
                        Ce champ est obligatoire.
                    </div>
                    <div class="invalid-feedback" v-if="!$v.userData.email.email">
                        Le champ email doit être valide.
                    </div>
                </div>
            </div>
            <!--end form-group-->

            <div class="form-group">
                <label for="userpassword">Mot de passe</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="fas fa-key icon-sm"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.userData.password.$error }"
                            class="form-control"
                            id="userpassword"
                            name="password"
                            placeholder="Entrez votre mot de passe"
                            type="password"
                            v-model.trim="$v.userData.password.$model"
                    />
                    <div class="invalid-feedback" v-if="!$v.userData.password.required">
                        Ce champ est obligatoire.
                    </div>
                    <div class="invalid-feedback"
                         v-if="!$v.userData.password.mustBeValidPassword && $v.userData.password.minLength">
                        Le champ du mot de passe doit contenir un nombre, une majuscule et un
                        lettre minuscule.
                    </div>
                    <div class="invalid-feedback" v-if="!$v.userData.password.minLength">
                        Le champ du mot de passe doit contenir au moins 6 caractères.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="input-group mb-3">
                    <vue-recaptcha :class="{ 'is-invalid': $v.userData.robot.$invalid }" :loadRecaptchaScript="true"
                                   :sitekey="DEFAULT_RECAPTCHA_KEY"
                                   @verify="markRecaptchaAsVerified"></vue-recaptcha>
                    <div class="invalid-feedback" v-if="!$v.userData.robot.required">
                        Ce champ est obligatoire.
                    </div>
                </div>
            </div>
            <div class="form-group row mt-4">
                <!--end col-->
                <div class="col-sm-6 text-right ml-auto">
                    <router-link class="text-muted font-13" to="/auth/recovery-code">
                        <i class="fas fa-unlock-alt"></i> Mot de passe oublié ?
                    </router-link>
                </div>
                <!--end col-->
            </div>
            <!--end form-group-->

            <div class="form-group mb-0 row">
                <div class="col-12 mt-2">
                    <button
                            :disabled="$v.userData.$invalid || isLoading"
                            @click="submit"
                            class="btn btn-login-gradient btn-round btn-block waves-effect waves-light"
                            type="button"
                    >
                        <b-spinner small v-if="isLoading"></b-spinner>
                        Se connecter <i class="fas fa-sign-in-alt"></i>
                    </button>
                </div>
                <!--end col-->
            </div>
            <!--end form-group-->
        </form>
        <!--end form-->
        <social-login @error="socialLoginError($event)"/>
    </div>
</template>

<script>
    import {
        email,
        helpers,
        minLength,
        required
    } from 'vuelidate/lib/validators';
    import SocialLogin from './socialLogin';
    import {titles} from '../../../utils/general/titles';
    import VueRecaptcha from 'vue-recaptcha';
    import {DEFAULT_RECAPTCHA_KEY} from '../../../config/config';
    import {setEnabledConfirmationUser} from '../../shared/services/user.service';

    const mustBeValidPassword = helpers.regex('alpha', /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/);

    export default {
        name: 'loginTab',
        components: {SocialLogin, VueRecaptcha},
        data() {
            return {
                DEFAULT_RECAPTCHA_KEY,
                errorMsg: '',
                isLoading: false,
                userData: {
                    email: '',
                    password: '',
                    token: null,
                    robot: null,
                    country: ''
                },
                recaptchaVerified: false
            };
        },
        validations: {
            userData: {
                email: {
                    required,
                    email
                },
                password: {
                    required,
                    mustBeValidPassword,
                    minLength: minLength(6)
                },
                robot: {
                    required
                }
            }
        },
        created() {
            if (this.$route.params.token) {
                this.token = (this.$route.params.token.substring(2)).slice(0, -2);
                setEnabledConfirmationUser(this.token).then(response => response.data);
            }
        },
        methods: {
            markRecaptchaAsVerified(response) {
                this.recaptchaVerified = true;
                this.userData.robot = response;
            },
            submit() {
                if (this.recaptchaVerified) {
                    this.isLoading = true;
                    this.errorMsg = null;
                    this.$store
                        .dispatch('signin', {
                            email: this.userData.email,
                            password: this.userData.password,
                            idSelectedDomain:
                                this.$route.params.idSelectedDomain ? parseInt(this.$route.params.idSelectedDomain, 0) : null,
                            idSelectedPack:
                                this.$route.params.idSelectedPack ? parseInt(this.$route.params.idSelectedPack, 0): null
                        })
                        .then(
                            () => {
                                this.isLoading = false;
                            },
                            err => {
                                if (err.code == 401) {
                                    if (err.message == 'Invalid credentials.') {
                                        this.errorMsg = titles.invalidCredentials;
                                    } else {
                                        this.errorMsg = err.message;
                                    }
                                } else {
                                    this.errorMsg = 'An unknown error occurred.';
                                }
                                this.isLoading = false;
                            }
                        );
                }
            },
            socialLoginError(err) {
                this.errorMsg = err;
            }
        }
    };
</script>

<style scoped></style>
